import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34e81786"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "address-label" }, "ETH address", -1))
const _hoisted_2 = { class: "main-address" }
const _hoisted_3 = {
  key: 0,
  class: "resolved-address"
}

import { isAddress } from '@ethersproject/address';
import { onMounted, ref } from 'vue';
import { formatAddress, resolveAddressFromBadges, resolveENSFromBadges } from '@/lib/address';

interface RecipientAddressProps {
  address: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientAddress',
  props: {
    address: {}
  },
  setup(__props: any) {

const props = __props;



const recipientAddress = ref(props.address || '');
const ensAddress = ref('');
const hasEns = ref(false);

onMounted(async () => {
  await getENS();
});

const getENS = async () => {
  if (isAddress(recipientAddress.value)) {
    const ens = await resolveENSFromBadges(recipientAddress.value);

    if (ens) {
      ensAddress.value = ens;
      hasEns.value = true;
      return;
    }

    ensAddress.value = '';
    hasEns.value = false;
    return;
  }

  // If ENS address
  if (recipientAddress.value.includes('.')) {
    const address = await resolveAddressFromBadges(recipientAddress.value);

    if (address) {
      ensAddress.value = recipientAddress.value;
      recipientAddress.value = address;
      hasEns.value = true;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(hasEns.value ? ensAddress.value : _unref(formatAddress)(recipientAddress.value)), 1),
    (hasEns.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(formatAddress)(recipientAddress.value)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})